<template>
  <div class="col-sm-12 ml-3">
    <div class="row mb-3">
      <div class="col-sm-8 border border-light py-2">
        <div class="row">
          <div class="col-sm-3 pr-1">
            <multiselect
              v-model="pisoSelected"
              :options="listaPisos"
              label="nombre" track-by="id"
              select-label="" deselect-label="X"
              placeholder="Seleccione Piso"
              :searchable="true">
              <span slot="caret" v-if="!(pisoSelected===null)"></span>
              <span slot="noResult">Sin Resultados</span>
              <span slot="noOptions">Lista Vacia</span>
              <template slot="singleLabel" slot-scope="props">
                <small>{{props.option.nombre}}</small>
              </template>
              <template slot="option" slot-scope="props">
                <small>{{props.option.nombre}}</small>
              </template>
            </multiselect>
          </div>
          <div class="col-sm-3 px-1">
            <multiselect
              v-model="salaSelected"
              :options="listaSalasFiltered"
              label="nombre" track-by="id"
              select-label="" deselect-label="X"
              placeholder="Seleccione Sala"
              :searchable="true">
              <span slot="caret" v-if="!(salaSelected===null)"></span>
              <span slot="noResult">Sin Resultados</span>
              <span slot="noOptions">Lista Vacia</span>
              <template slot="singleLabel" slot-scope="props">
                <small>{{props.option.nombre}}</small>
              </template>
              <template slot="option" slot-scope="props">
                <small>{{props.option.nombre}}</small>
              </template>
            </multiselect>
          </div>
          <div class="col-sm-4 px-1">
            <multiselect
              v-model="claseSelected"
              :options="listaClases"
              label="nombre" track-by="id"
              select-label="" deselect-label="X"
              placeholder="Seleccione Clase"
              :searchable="true">
              <span slot="caret" v-if="!(claseSelected===null)"></span>
              <span slot="noResult">Sin Resultados</span>
              <span slot="noOptions">Lista Vacia</span>
              <template slot="singleLabel" slot-scope="props">
                <small>{{props.option.nombre}}</small>
              </template>
              <template slot="option" slot-scope="props">
                <small>{{props.option.nombre}}</small>
              </template>
            </multiselect>
          </div>
          <div class="col-sm-2 pl-1">
            <button
              class="btn btn-success col-sm-12"
              @click="agregarModificarItem"
              :disabled="inputDisabled"
            >
              {{textButtonForm}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 px-0">
        <b-table
          class="table table-striped table-hover"
          :busy="isLoading"
          :fields="fields"
          :items="listaPisoSala"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
              <strong>Cargando...</strong>
            </div>
          </template>
          <template #cell(editar)="items">
            <i
              @click="editarItem(items.item)"
              class="nav-icon i-Pen-5 text-success font-weight-bold"
              style="cursor: pointer"
            ></i>
          </template>
          <template #cell(eliminar)="items">
            <i
              @click="onClickEliminarIcon(items.item)"
              v-b-modal.modal-eliminar
              class="nav-icon i-Close-Window text-danger font-weight-bold"
              style="cursor: pointer"
            ></i>
          </template>
        </b-table>
        <b-modal id="modal-eliminar"
          :title="'Seguro que quieres eliminar el Registro - N° '+selectedNro+'?'"
          hide-footer
        >
          <div class="row">
            <div class="col-sm-6">
              <button class="col-sm-12 btn btn-danger" @click="eliminarRegistro">
                Eliminar
              </button>
            </div>
            <div class="col-sm-6">
              <button class="col-sm-12 btn btn-outline-dark"
              @click="$bvModal.hide('modal-eliminar')">Cancelar</button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';

export default {
  name: 'PisoSala',
  components: {
    Multiselect,
  },
  watch: {
    listaPisoSala() {
      this.updateComboSala();
    },
  },
  data() {
    return {
      pisoSelected: null,
      listaPisos: [],
      salaSelected: null,
      listaSalas: [],
      listaSalasFiltered: [],
      claseSelected: null,
      listaClases: [],
      inputDisabled: false,
      textButtonForm: 'Agregar',
      isLoading: true,
      modoEdicion: false,
      fields: [
        {
          key: 'editar', label: ' ', class: 'text-center', thStyle: { width: '5%' },
        },
        {
          key: 'eliminar', label: ' ', class: 'text-center', thStyle: { width: '5%' },
        },
        {
          key: 'numero', label: 'ID', thStyle: { width: '8%' },
        },
        {
          key: 'piso_nombre', label: 'Piso', thStyle: { width: '27%' },
        },
        {
          key: 'sala_nombre', label: 'Sala', thStyle: { width: '27%' },
        },
        {
          key: 'clase_nombre', label: 'Clase', thStyle: { width: '28%' },
        },
      ],
      listaPisoSala: [],
      selectedId: null,
      selectedNro: null,
    };
  },
  async created() {
    await this.cargarDatosIniciales();
    this.listarPisoSalas();
  },
  methods: {
    async cargarDatosIniciales() {
      this.isLoading = true;
      try {
        const RESPONSE = await axios.get('/clinic/parametros/piso_salas/create');
        this.listaClases = RESPONSE.data.data.clases;
        this.listaPisos = RESPONSE.data.data.pisos;
        this.listaSalas = RESPONSE.data.data.salas;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      } finally {
        this.isLoading = false;
      }
    },
    async listarPisoSalas() {
      this.isLoading = true;
      try {
        const RESPONSE = await axios.get('/clinic/parametros/piso_salas');
        this.listaPisoSala = RESPONSE.data.data;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      } finally {
        this.isLoading = false;
      }
    },
    async guardarDatos() {
      const REQUEST = {
        piso_id: this.pisoSelected.id,
        sala_id: this.salaSelected.id,
        clase_id: this.claseSelected.id,
      };
      let estado = false;
      try {
        const RESPONSE = await axios.post('/clinic/parametros/piso_salas', REQUEST);
        await this.listarPisoSalas();
        util.showNotify(RESPONSE.data.message, 'success');
        estado = true;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
      return estado;
    },
    async actualizarItem() {
      const REQUEST = {
        piso_id: this.pisoSelected.id,
        sala_id: this.salaSelected.id,
        clase_id: this.claseSelected.id,
      };
      let estado = false;
      try {
        const response = await axios.put(`/clinic/parametros/piso_salas/${this.selectedId}`, REQUEST);
        await this.listarPisoSalas();
        util.showNotify(response.data.message, 'success');
        estado = true;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
      return estado;
    },
    activarModoEdicion() {
      this.modoEdicion = true;
      this.textButtonForm = 'Modificar';
    },
    desactivarModoEdicion() {
      this.modoEdicion = false;
      this.textButtonForm = 'Agregar';
    },
    agregarModificarItem() {
      if (this.pisoSelected === null) {
        util.showNotify('Elije un Piso.', 'warn');
        return;
      }
      if (this.salaSelected === null) {
        util.showNotify('Elije una Sala.', 'warn');
        return;
      }
      if (this.claseSelected === null) {
        util.showNotify('Elije una Clase.', 'warn');
        return;
      }
      this.inputDisabled = true;
      if (this.modoEdicion) {
        if (this.actualizarItem()) {
          this.pisoSelected = null;
          this.salaSelected = null;
          this.claseSelected = null;
          this.selectedId = null;
          this.desactivarModoEdicion();
        }
      } else {
        this.selectedId = null;
        this.selectedNro = null;
        if (this.guardarDatos()) {
          this.pisoSelected = null;
          this.salaSelected = null;
          this.claseSelected = null;
        }
      }
      this.inputDisabled = false;
    },
    setItems(fila) {
      this.selectedId = fila.id;
      this.selectedNro = fila.numero;
    },
    onClickEliminarIcon(item) {
      if (this.modoEdicion) {
        this.pisoSelected = null;
        this.salaSelected = null;
        this.claseSelected = null;
        this.updateComboSala();
        this.desactivarModoEdicion();
      }
      this.setItems(item);
    },
    eliminarRegistroLocalmente() {
      this.listaPisoSala = this.listaPisoSala.filter((item) => (
        item.id !== this.selectedId
      ));
    },
    async eliminarRegistro() {
      this.$bvModal.hide('modal-eliminar');
      try {
        this.eliminarRegistroLocalmente();
        const RESPONSE = await axios.delete(`/clinic/parametros/piso_salas/${this.selectedId}`);
        util.showNotify(RESPONSE.data.message, 'success');
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
        await this.listarPisoSalas();
      }
    },
    cargarComboPisoById(id) {
      if (id === null) {
        return;
      }
      this.pisoSelected = this.listaPisos.find((el) => el.id === id);
    },
    cargarComboSalaById(id) {
      if (id === null) {
        return;
      }
      this.salaSelected = this.listaSalas.find((el) => el.id === id);
    },
    cargarComboClaseById(id) {
      if (id === null) {
        return;
      }
      this.claseSelected = this.listaClases.find((el) => el.id === id);
    },
    async getDataToEdit() {
      try {
        const RESPONSE = await axios.get(`/clinic/parametros/piso_salas/${this.selectedId}/edit`);
        const PISO_ID = RESPONSE.data.data.piso_id;
        const SALA_ID = RESPONSE.data.data.sala_id;
        const CLASE_ID = RESPONSE.data.data.clase_id;
        this.cargarComboPisoById(PISO_ID);
        this.cargarComboSalaById(SALA_ID);
        this.cargarComboClaseById(CLASE_ID);
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    editarItem(item) {
      this.activarModoEdicion();
      this.selectedId = item.id;
      this.selectedNro = null;
      this.getDataToEdit();
      this.updateComboSalaFromEditar();
    },
    updateComboSalaFromEditar() {
      if (this.modoEdicion === true) {
        let listaTemporal = [...this.listaSalas];
        this.listaPisoSala.forEach((item) => {
          if (item.id === this.selectedId) {
            listaTemporal = listaTemporal.filter((el) => (
              el.id !== item.sala_id || this.selectedId === item.id
            ));
          } else {
            listaTemporal = listaTemporal.filter((el) => el.id !== item.sala_id);
          }
        });
        this.listaSalasFiltered = listaTemporal;
      }
    },
    updateComboSala() {
      let listaTemporal = [...this.listaSalas];
      this.listaPisoSala.forEach((item) => {
        listaTemporal = listaTemporal.filter((el) => el.id !== item.sala_id);
      });
      this.listaSalasFiltered = listaTemporal;
    },
  },
};
</script>

<style scoped>
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
